// Ratgeber table of contents: keeps the sticky offset below the sticky header in
// --ms-sticky-top, highlights the last chapter scrolled past and smooth-scrolls to clicked chapters.
(() => {
  const toc = document.querySelector('[data-guide-toc]');
  if (!toc) return;

  const guide = toc.closest('.medic-star-guide');
  const links = Array.from(toc.querySelectorAll('a[href^="#"]'));
  const headings = links.map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1))));
  if (!headings.some(Boolean)) return;

  const setOffset = () => {
    const header = document.querySelector('.medic-star-header--sticky');
    guide.style.setProperty('--ms-sticky-top', `${(header ? header.offsetHeight : 0) + 24}px`);
  };

  let active = -1;
  const update = () => {
    const line = window.innerHeight * 0.35;
    let index = 0;
    headings.forEach((heading, i) => {
      if (heading && heading.getBoundingClientRect().top <= line) index = i;
    });
    if (index === active) return;
    active = index;
    links.forEach((link, i) => link.classList.toggle('is-active', i === index));
    const link = links[index];
    if (link.offsetTop < toc.scrollTop || link.offsetTop + link.offsetHeight > toc.scrollTop + toc.clientHeight) {
      toc.scrollTop = link.offsetTop - toc.clientHeight / 2;
    }
  };

  let ticking = false;
  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    },
    { passive: true }
  );
  window.addEventListener('resize', setOffset);
  setOffset();
  update();

  toc.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    const target = link && document.getElementById(decodeURIComponent(link.hash.slice(1)));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
    history.replaceState(null, '', link.hash);
  });
})();
